import { Button } from '@eventbrite/marmalade';
import { ErrorPage } from '../ErrorPage/ErrorPage';
import styles from '../ErrorPage/ErrorPage.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { type ErrorResponse, errorMessages } from '@/utils/error-handling';
import { GenericErrorIllustration } from '../Illustrations/GenericErrorIllustration';
import { Stage } from '@eventbrite/webapp-constants';

export function GenericErrorPage({
  error = {
    message: errorMessages.genericError.message.id,
    description: errorMessages.genericError.description.id,
  },
  stage,
}: {
  error?: Omit<ErrorResponse, 'statusCode'>;
  stage: Stage;
}): JSX.Element {
  const { formatMessage } = useIntl();
  const handleClick = () => {
    // TODO: confirm if this is the correct URL
    window.location.href = 'https://www.eventbrite.com/directory';
  };

  return (
    <ErrorPage
      title={formatMessage({ id: error.message })}
      description={formatMessage({ id: error.description })}
      stage={stage}
    >
      <main className={styles.errorPageBody} data-testid="error-page">
        <GenericErrorIllustration />
        <div className={styles.errorPageContent}>
          <h2 className={styles.errorPageTitle}>
            <FormattedMessage id={error.message} />
          </h2>
          <p className={styles.errorPageDescription}>
            <FormattedMessage id={error.description} />
          </p>
        </div>
        <Button id="browse-more-events-button" onClick={handleClick} role="button" variant="primary">
          <FormattedMessage id="Browse more events" />
        </Button>
      </main>
    </ErrorPage>
  );
}
